import * as React from 'react';
import { IEntityFormProps2, IGIAAImportInfo, GIAAImport } from '../../types';
import * as services from '../../services';
import styles from '../../styles/cr.module.scss';
import { UpdateHeader2 } from '../cr/UpdateHeader2';
import MainList from './MainList';
import { IUseUserContextProps } from '../useUserContext';

export interface ISectionProps extends IEntityFormProps2 {
    isArchive: boolean;
    sectionTitle: string;
    dgAreaId: number | string;
    onItemTitleClick: (ID: number, title: string, filteredItems: any[]) => void;
    incompleteOnly: boolean;
    onChangeIncompleteOnly: (value: boolean) => void;
    justMine: boolean;
    onChangeJustMine: (value: boolean) => void;
    listFilterText: string;
    onChangeFilterText: (value: string) => void;
    section_IsOpen: boolean;
    onSection_toggleOpen: () => void;
    onMainSaved: () => void;
    mainListsSaveCounter: number;
    superUserPermission: boolean;
    orbUserContext: IUseUserContextProps;
}

export class SectionState {
    public Loading: boolean = false;
    public UpdatesReqInProgress: boolean = false;
    public CheckUpdatesReqPressed: boolean = false;
    constructor() {
    }
}

export default class Section extends React.Component<ISectionProps, SectionState> {
    private gIAAImportService: services.GIAAImportService = new services.GIAAImportService();
    constructor(props: ISectionProps, state: SectionState) {
        super(props);
        this.state = new SectionState();
    }

    public render(): React.ReactElement<ISectionProps> {
        const ShowForm = this.props.section_IsOpen;
        const currentDateTime: string = services.DateService.dateToUkDateTime(new Date());

        return (
            <div className={styles.cr}>
                <UpdateHeader2 title={this.props.sectionTitle} isOpen={ShowForm}
                    leadUser=""
                    hideRagIndicator={true}
                    rag={null}
                    ragLabel={null}
                    onClick={this.props.onSection_toggleOpen} />

                {ShowForm && <div>
                    <div style={{ width: 'auto', minHeight: '120px', marginTop: '10px', marginLeft: 'auto', marginRight: 'auto' }}>
                        <MainList
                            {...this.props}
                            isArchive={this.props.isArchive}
                            errorHandling={this.props.errorHandling}
                            onItemTitleClick={this.props.onItemTitleClick}
                            incompleteOnly={this.props.incompleteOnly}
                            onChangeIncompleteOnly={this.props.onChangeIncompleteOnly}
                            justMine={this.props.justMine}
                            onChangeJustMine={this.props.onChangeJustMine}
                            dgAreaId={this.props.dgAreaId}
                            filterText={this.props.listFilterText}
                            onChangeFilterText={this.props.onChangeFilterText}
                            onMainSaved={this.props.onMainSaved}
                            mainListsSaveCounter={this.props.mainListsSaveCounter}
                            superUserPermission={this.props.superUserPermission}
                            onCheckUpdatesRequest={this.handleUpdatesReq}
                            updatesReqInProgress={this.state.UpdatesReqInProgress}
                        />
                    </div>
                    <div style={{ paddingTop: "10px", paddingLeft: "10px", }}>
                        <div style={{ fontStyle: "italic", paddingBottom: '10px', }}>Please click on a Title to view or update recommendations.</div>
                        {this.state.CheckUpdatesReqPressed && this.state.UpdatesReqInProgress === true && <div>{currentDateTime}: Working....Please wait.<br />
                            All recommendations will now be checked and if necessary, will set the status to 'Overdue' and updates fields to 'Req Updates'.<br />
                            <span style={{ cursor: 'pointer', color: 'blue' }} onClick={() => this.loadImporInProgressInfo()} >Refresh</span></div>
                        }
                        {this.state.CheckUpdatesReqPressed && this.state.UpdatesReqInProgress === false && <div>{currentDateTime}: Completed<br />
                            All recommendations have been checked and where necessary, the status has been set to 'Overdue' and update field to 'Req Updates'</div>
                        }
                    </div>
                    <br /><br />
                </div>}
            </div>
        );
    }

    public componentDidMount(): void {
        this.loadImporInProgressInfo();
    }

    private handleUpdatesReq = (): void => {
        const giaaImport = new GIAAImport();
        giaaImport.XMLContents = "Check Updates Req";

        this.gIAAImportService.create(giaaImport).then(x => {
            this.setState({ UpdatesReqInProgress: true, CheckUpdatesReqPressed: true });
        });
    }

    private loadImporInProgressInfo = (): Promise<void> => {
        let x = this.gIAAImportService.getImportInfo().then((e: IGIAAImportInfo): void => {
            let inProgress: boolean = false;
            if (e.Status == "InProgress") {
                inProgress = true;
            }
            else {
                this.props.onMainSaved();
            }
            this.setState({
                UpdatesReqInProgress: inProgress
            });

        }, (err) => { if (this.props.errorHandling?.onError) this.props.errorHandling?.onError(`Error loading data`, err.message); });
        return x;
    }
}
